<template>
  <div class="index">
    <!-- 中间图片部分 -->
    <div class="center">
      <img
        src="https://fview.5kjs.com/activity/21sign/image/pc/indexImage/leftOne.png"
        alt=""
        class="leftOne_bg"
      />
      <img
        src="https://fview.5kjs.com/activity/21sign/image/pc/indexImage/rightOne.png"
        alt=""
        class="rightOne_bg"
      />
      <div class="table1">
        <CenterTable>
          <!-- 表格标题 -->
          <template v-slot:title>备考2022你所面临的问题</template>
          <!-- 表格内容部分 -->
          <template v-slot:content>
            <div class="center_table">
              <div class="center_table_title">
                顶级名师为2022年考编人定制备考计划：让你遇见新的自己
              </div>
              <div class="center_table_content">
                <div class="center_table_item">
                  <div class="duigou">
                    <img
                      src="https://fview.5kjs.com/activity/21sign/image/pc/indexImage/duigou.png"
                      alt=""
                    />
                  </div>
                  <div class="center_table_text">自控能力差，需要监督?</div>
                </div>
                <div class="center_table_item">
                  <div class="duigou">
                    <img
                      src="https://fview.5kjs.com/activity/21sign/image/pc/indexImage/duigou.png"
                      alt=""
                    />
                  </div>
                  <div class="center_table_text">
                    教综高频考点及真题解析去哪找?
                  </div>
                </div>
                <div class="center_table_item">
                  <div class="duigou">
                    <img
                      src="https://fview.5kjs.com/activity/21sign/image/pc/indexImage/duigou.png"
                      alt=""
                    />
                  </div>
                  <div class="center_table_text">每次考试都被“教综”拖后腿?</div>
                </div>
                <div class="center_table_item">
                  <div class="duigou">
                    <img
                      src="https://fview.5kjs.com/activity/21sign/image/pc/indexImage/duigou.png"
                      alt=""
                    />
                  </div>
                  <div class="center_table_text">
                    闲暇时间，如何养成学习好习惯?
                  </div>
                </div>
                <div class="center_table_item">
                  <div class="duigou">
                    <img
                      src="https://fview.5kjs.com/activity/21sign/image/pc/indexImage/duigou.png"
                      alt=""
                    />
                  </div>
                  <div class="center_table_text">无人指导,只能低水平重复?</div>
                </div>
                <div class="center_table_item">
                  <div class="duigou">
                    <img
                      src="https://fview.5kjs.com/activity/21sign/image/pc/indexImage/duigou.png"
                      alt=""
                    />
                  </div>
                  <div class="center_table_text">湖南各区教招教综难度如何?</div>
                </div>
                <div class="center_table_item">
                  <div class="duigou">
                    <img
                      src="https://fview.5kjs.com/activity/21sign/image/pc/indexImage/duigou.png"
                      alt=""
                    />
                  </div>
                  <div class="center_table_text">想备考2022教招，怎么复习?</div>
                </div>
                <div class="center_table_item">
                  <div class="duigou">
                    <img
                      src="https://fview.5kjs.com/activity/21sign/image/pc/indexImage/duigou.png"
                      alt=""
                    />
                  </div>
                  <div class="center_table_text">刷题不少，分数却难以提高?</div>
                </div>
              </div>
            </div>
          </template>
        </CenterTable>
      </div>
    </div>
    <!-- 底部图片部分 -->
    <div class="footer">
      <img
        src="https://fview.5kjs.com/activity/21sign/image/pc/indexImage/leftTwo.png"
        alt=""
        class="leftTwo_bg"
      />
      <img
        src="https://fview.5kjs.com/activity/21sign/image/pc/indexImage/rightTwo.png"
        alt=""
        class="rightTwo_bg"
      />
      <!-- 第二个表格 -->
      <div class="table2" id="card">
        <CenterTable>
          <!-- 第二个表格标题 -->
          <template v-slot:title>打卡报名时</template>
          <!-- 第二个表格内容 -->
          <template v-slot:content>
            <div class="content_table2">
              <!-- 上端路由部分 -->
              <div class="content_table2_title" ref="listUlBox">
                <!-- <div class="left"> -->
                <ul class="content_table2_title_ul"  ref="listUl" @mouseenter="ulhover()" @mouseleave="ulLeave()">
                  <li
                    :class="{ active: item.camp_id == cardNumber }"
                    v-for="item in cardRouter"
                    :key="item.camp_id"
                    @click="changeActive(item.camp_id)"
                  >
                    <router-link
                      :to="'/index/home/card/' + item.camp_id"
                      :title="item.subject_name"
                    >
                      <div class="content_table2_title_box">
                        <p class="content_table2_title_style">
                          {{ item.subject_name }}
                        </p>
                        <div class="diheng"></div>
                      </div>
                    </router-link>
                  </li>
                </ul>
                <!-- </div> -->
                <!-- 表格二右侧折叠栏部分 -->
                <!-- <div
                  class="right moreClass_box"
                  v-if="moreCardRouter.length != 0"
                >
                  <el-dropdown
                    trigger="click"
                    @command="moreClick"
                    placement="bottom"
                  >
                    <span class="el-dropdown-link" style="font-size: 1.25rem">
                      更多科目<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu
                      slot="dropdown"
                      style="padding: 0; width: 8.4375rem"
                    >
                      <el-dropdown-item
                        v-for="item in moreCardRouter"
                        :key="item.camp_id"
                        :command="item.camp_id"
                        style="
                          padding: 0.5rem;
                          color: #999999;
                          border-bottom: 1px solid #f1f1f1;
                          height: auto;
                          line-height: 1.375rem;
                          text-align: center;
                          font-size: 0.875rem;
                        "
                      >
                        {{ item.subject_name }}</el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </el-dropdown>
                </div> -->
              </div>
              <!-- 下端路由窗口部分 -->
              <div class="content_table2_text">
                <router-view />
              </div>
            </div>
          </template>
        </CenterTable>
      </div>
      <div class="table3" id="QA">
        <CenterTable>
          <template v-slot:title>常见问题Q&A </template>
          <template v-slot:content>
            <div v-if="qa != null">
              <div class="content_table3">
                <!-- QA问答部分 -->
                <div>
                  <div
                    class="content_table3_item"
                    v-for="item in qa"
                    :key="item.id"
                  >
                    <p class="content_table3_item_text_Q">
                      Q：{{ item.problem }}
                    </p>
                    <p class="content_table3_item_text_A">
                      <span class="content_table3_item_text_Q">A：</span>
                      {{ item.answer }}
                    </p>
                  </div>
                </div>
                <div class="contact">
                  <!-- <a target="_blank" href="tencent://AddContact/?fromId=50&fromSubId=1&subcmd=all&uin=2070232090"> -->
                  <div>
                    <el-popover placement="top" title="" trigger="hover">
                      <div class="QRcode">
                        <div class="box">
                          <img
                            src="https://fview.5kjs.com/activity/21sign/image/pc/QRcode.jpg"
                            alt=""
                            class="QRcode"
                          />
                        </div>
                      </div>
                      <div class="contact_text" slot="reference">
                        <i class="iconfont icon-wodekefu contact_text"></i>
                        <span class="marginTen">有疑问？咨询在线老师</span>
                      </div>
                    </el-popover>
                  </div>
                  <!-- </a> -->
                </div>
              </div>
            </div>
            <!-- 空状态 -->
            <div v-else style="width: 100%; height: 25rem">
              <div
                style="
                  margin: auto;
                  width: 18rem;
                  height: 18rem;
                  text-align: center;
                "
              >
                <img
                  style="width: 90%; height: 90%"
                  src="https://fview.5kjs.com/activity/21sign/image/pc/kong.png"
                  alt=""
                />
                <div style="color: #333333">暂时没有数据</div>
              </div>
            </div>
          </template>
        </CenterTable>
      </div>
    </div>
  </div>
</template>

<script>
import CenterTable from "@/components/CenterTable.vue";
import { mapMutations } from "vuex";
export default {
  name: "index",
  data() {
    return {
      // 打卡报名活跃标签序号
      cardNumber: 0,
      // 打卡表格的路由(请求数据)
      cardRouter: [],
      // 更多路由
      moreCardRouter: [],
      // QA问答
      qa: [],
    };
  },
  methods: {
    ...mapMutations(["getcardRouter", "scrollToTop"]),
    // 更多菜单点击事件
    moreClick(camp_id) {
      this.$router.push({ path: `/Detail/apply/${camp_id}` });
      this.scrollToTop(0);
    },
    changeActive(index) {
      this.cardNumber = index;
    },
    // 初始化当前选项卡路由
    getCardNumber() {
      // 获取URL值并截取出list路由的值赋值给当前活动的选项
      var url = window.location + "";
      url = url.split("/card/")[1];
      if (url != 0) {
        this.cardNumber = url;
      } else {
        this.getcardRouter(this.cardRouter[0].camp_id);
        this.cardNumber = this.cardRouter[0].camp_id;
        this.$router.push("/index/home/card/" + this.cardNumber);
      }
    },
    // 请求打卡list列表数据
    getSubjectList() {
      this.$axios
        .get("/getSubjectList", {
          params: {
            agency_id: this.agency_id,
            // token: this.token,
          },
        })
        .then((doc) => {
          if (doc == null) {
            return;
          } else {
            // 用来分割请求下来的训练营
            // if (doc.length > 4) {
            //   this.cardRouter = doc.slice(0, 4);
            //   this.moreCardRouter = doc.slice(4);
            // } else {
            //   this.cardRouter = doc;
            // }
            this.cardRouter = doc;
            this.getCardNumber();

            // ——————————————————————初始化路由判断
            let skip = false;
            let nowRouter = this.$route.params.id;
            // 如果当前路由再请求路由列表中则不变 否则跳转为请求列表第一个路由
            doc.forEach((item) => {
              if (item.camp_id == nowRouter) {
                this.cardNumber = item.camp_id;
                skip = true;
                return;
              }
            });

            if (skip) {
              console.log(" ");
            } else {
              console.log(`/index/home/card/${doc[0].camp_id}`);
              this.$router.push({ path: `/index/home/card/${doc[0].camp_id}` });
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 请求QA问答列表数据
    getQuestionsAndAnswers() {
      this.$axios
        .get("/getQuestionsAndAnswers", {
          params: {
            agency_id: this.agency_id,
          },
        })
        .then((doc) => {
          this.qa = doc;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 鼠标悬浮进入显示滑动条事件
    ulhover(){
      this.$(this.$refs.listUlBox).css({ "overflow": "visible"})
    },
    // 鼠标离开隐藏滑动条事件
    ulLeave(){
       this.$(this.$refs.listUlBox).css({ "overflow": "hidden"})
    }
  },
  components: {
    CenterTable,
  },
  mounted() {
    this.getSubjectList();
    // 请求QA问答数据
    this.getQuestionsAndAnswers();

    // 备选方案二，鼠标可拖动栏开始----------------------------------------\
     var that = this;//用来存放VUE指针
    that.$(that.$refs.listUl).on("mousedown", function (e) {
      var startline =e.clientX//初始化获取鼠标按下去的时候坐标
      var scrollStart = that.$refs.listUl.scrollLeft//初始化获取当前滑动条所在的坐标
      // 鼠标按下的时候移动鼠标触发鼠标移动事件
      that.$(that.$refs.listUl).on("mousemove", function (e) {
        var endStart =  (e.clientX - startline)* -1+ scrollStart//当前移动的坐标位置减去初始化点击坐标加上初始化滑动栏的坐标等于现在的坐标
        that.$refs.listUl.scrollTo(endStart,0)//赋值坐标
      });
      //如果鼠标按键抬起，移除移动事件
      that.$(this).one("mouseup", function () {
        that.$(that.$refs.listUl).unbind("mousemove")
      });
      //如果鼠标离开当前范围，移除移动事件
      that.$(this).one("mouseleave", function () {
        that.$(that.$refs.listUl).unbind("mousemove")
      });
    });
    // 备选方案二，鼠标可拖动栏结束----------------------------------------\


    
  },
  computed: {
    // ...mapState(["token", "agency_id"]),
    agency_id() {
      if (localStorage.getItem("agency_id")) {
        return localStorage.getItem("agency_id");
      } else {
        return 281;
      }
    },
    token() {
      if (localStorage.getItem("token")) {
        return localStorage.getItem("token");
      } else {
        return null;
      }
    },
  },
  watch: {
    agency_id(val) {
      this.getSubjectList();
      return val;
    },
  },
};
</script>

<style lang="less" scoped>
//   内容中间部分
.center {
  width: 100%;
  height: 45.4375rem;
  background: url(https://fview.5kjs.com/activity/21sign/image/pc/indexImage/center.png)
    no-repeat;
  background-size: 100% 100%;
  //中间表格部分
  .leftOne_bg {
    position: absolute;
    left: 0;
    top: 98.25rem;
    z-index: 0;
    width: 15rem;
    height: 49.5rem;
  }
  .rightOne_bg {
    position: absolute;
    right: 6.1875rem;
    top: 114.25rem;
    z-index: 0;
    width: 10.5625rem;
    height: 23.4375rem;
  }
  .center_table {
    margin: auto;
    padding-bottom: 1.875rem;
    width: 66.9375rem;
    // height: 36rem;
    height: auto;
    // 中间表格标题
    .center_table_title {
      width: 66.9375rem;
      height: 6rem;
      background: linear-gradient(90deg, #d20309, #fc4a4a, #fbb188);
      box-shadow: 0.25rem 0.1875rem 0.5rem 0rem rgba(255, 77, 42, 0.35);
      border-radius: 1.6875rem;
      font-size: 2.3125rem;
      font-family: " Source Han Sans CN";
      font-weight: bold;
      color: #ffffff;
      line-height: 6rem;
      text-align: center;
    }
    // 中间表格内容
    .center_table_content {
      overflow: hidden;
      margin-top: 4.0625rem - 2.375rem;
      padding-bottom: 4.3125rem;
      .center_table_item {
        box-sizing: border-box;
        margin-top: 2.375rem;
        float: left;
        display: flex;
        flex-direction: row;
        width: 50%;
        height: 4.0625rem;

        .duigou {
          width: 3.875rem;
          height: 3.8125rem;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .center_table_text {
          box-sizing: border-box;
          padding-left: 2.1875rem;
          width: 26.375rem;
          height: 4.0625rem;
          background: #ffffff;
          border: 0.125rem solid #fbb68b;
          border-radius: 2.0625rem;
          font-size: 1.625rem;
          font-family: "Source Han Sans CN";
          font-weight: bold;
          color: #373737;
          line-height: 4.0625rem;
        }
      }
    }
  }
  // 选择偶数
  .center_table_item:nth-child(even) {
    .center_table_text {
      width: 28.25rem !important;
    }
  }
}
// 内容最下部分
.footer {
  padding-bottom: 6.875rem;
  width: 100%;
  height: auto;
  // 第二个表格
  .leftTwo_bg {
    position: absolute;
    right: 0;
    top: 187.25rem;
    z-index: 0;
    width: 15rem;
    height: 49.5rem;
  }
  .rightTwo_bg {
    position: absolute;
    left: 6.1875rem;
    top: 214.25rem;
    z-index: 0;
    width: 10.5625rem;
    height: 23.4375rem;
  }
  .table2 {
    margin-top: 18.25rem;
    // 第二个表格内容
    .content_table2 {
      box-sizing: border-box;
      width: 100%;
      padding-bottom: 2.6875rem;
      // 第二个表格标题
      .content_table2_title {
        // margin-top: -2.5rem;
        position: relative;
        top: -1.875rem;
        height: 3.125rem;
        padding: 0 2.625rem 0 2.6875rem;
        border-bottom: 0.0625rem solid #f1f1f1;
        overflow: hidden;
        // 路由导航

        .content_table2_title_ul {

          display: flex;
          flex-direction: row;
          width: 100%;
          overflow: hidden;
          overflow-x: auto;

          -webkit-touch-callout: none;
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
          user-select: none;
          li {
            // padding: 0 1.25rem;
            // text-align: center;
            margin: 0 .9375rem;
            flex: 1;

            .content_table2_title_box {
              z-index: 99;
              display: flex;
              flex-direction: column;
              align-items: center;
              .content_table2_title_style {
                // max-width: 9rem;
                overflow: hidden; /*超出部分隐藏*/
                white-space: nowrap; /*不换行*/
                text-overflow: ellipsis; /*超出部分文字以...显示*/
                font-size: 1.25rem;
                font-family: "Microsoft YaHei";
                font-weight: bold;
                color: #585858;
                line-height: 2.8125rem;
              }
              .diheng {
                transition: all 1s ease;
                width: 0;
                height: 0;
                background: #ff8214;
                border-radius: 0.1875rem;
              }
            }
          }
          li.active {
            .content_table2_title_style {
              color: #ff8214;
            }
            .diheng {
              width: 1.9375rem;
              height: 0.3125rem;
              background: #ff8214;
              border-radius: 0.1875rem;
            }
          }
        }
        // 导航右侧下拉菜单
        /deep/ .el-menu {
          height: 3.125rem;
          background: transparent;
          border-bottom: none;
          .el-submenu {
            height: 3.125rem;
            .el-submenu__title {
              height: 3.125rem;
              font-size: 1.25rem;
              font-family: "Microsoft YaHei";
              font-weight: 400;
              color: #333333;
              line-height: 2.8125rem;
            }
            .el-submenu__title:hover {
              background: transparent;
            }
            .el-icon-arrow-down:before {
              font-size: 1.25rem;
              font-weight: 400;
              color: #333333;
            }
          }
        }
        /deep/ .moreClass_box {
          flex-shrink: 0;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          .el-dropdown {
            font-size: 1.25rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            .el-dropdown-menu {
              width: 8.375rem;
            }
          }
        }
      }
      .content_table2_text {
        padding: 0 2.625rem 0 2.6875rem;
      }
    }
  }
  .table3 {
    margin-top: 8.125rem;
    // 第三个表格
    .content_table3 {
      width: 100%;
      padding-bottom: 4.4375rem;
      height: auto;
      .content_table3_item {
        box-sizing: border-box;
        padding: 1.75rem 4rem 1.75rem 4.125rem;
        border-bottom: 0.0625rem solid #f1f1f1;
        .content_table3_item_text_Q {
          font-size: 1.375rem;
          font-family: " Microsoft YaHei";
          font-weight: bold;
          color: #3d3333;
          line-height: 2.4375rem;
        }
        .content_table3_item_text_A {
          font-size: 1.25rem;
          color: #3d3333;
          font-weight: 400;
        }
      }
      // 取消最后一个问题的下边框
      .content_table3_item:last-child {
        border: none;
        margin-bottom: 4.8125rem;
      }
      // 联系我们部分
      .contact {
        margin: auto;
        width: 32.75rem;
        height: 4.5625rem;
        background: linear-gradient(144deg, #ff5a25, #ff7d3a);
        border-radius: 0.4375rem;

        .contact_text {
          font-size: 1.625rem;
          font-family: "Microsoft YaHei";
          font-weight: 400;
          color: #ffffff;
          line-height: 4.4375rem;
          text-shadow: 0rem 0.1875rem 0.25rem rgba(163, 40, 0, 0.29);
          text-align: center;
          .marginTen {
            margin-left: 0.625rem;
          }
        }
      }
      .contact:hover {
        background: linear-gradient(144deg, #ff7d3a, #ff5a25);
      }
    }
  }
}
</style>